import { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  People as PeopleIcon,
  Badge as RoleIcon,
  Group as UsersIcon,
} from '@mui/icons-material';
import Layout from '../components/Layout';
import ContactsSettings from '../components/settings/ContactsSettings';
import RolesSettings from '../components/settings/RolesSettings';
import UsersSettings from '../components/settings/UsersSettings';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

export default function Settings() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Layout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
          Account Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your contacts, team roles, and users
        </Typography>
      </Box>

      <Paper elevation={2}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="settings tabs"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            px: 2,
          }}
        >
          <Tab
            icon={<UsersIcon />}
            iconPosition="start"
            label="Users"
            {...a11yProps(0)}
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
          <Tab
            icon={<PeopleIcon />}
            iconPosition="start"
            label="Contacts"
            {...a11yProps(1)}
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
          <Tab
            icon={<RoleIcon />}
            iconPosition="start"
            label="Team Roles"
            {...a11yProps(2)}
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <UsersSettings />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <ContactsSettings />
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <RolesSettings />
        </TabPanel>
      </Paper>
    </Layout>
  );
}